import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { ITranslationContextValue } from '../Translate/models/index.js';
import { TranslationContext } from '../Translate/Translate.js';

import { IInputComponentProps, IInputConfiguration, IInputState } from './models/index.js';
import { INPUT_CATEGORY_KEY, INPUT_COMPONENT_KEY } from './Input.meta.js';

export class Input extends ComponentBase<IInputComponentProps, IInputState, IInputConfiguration> {
	categoryKey = INPUT_CATEGORY_KEY;
	componentKey = INPUT_COMPONENT_KEY;
	inputRef: any;

	constructor(props: IInputComponentProps) {
		super(props);
		this.inputRef = props.innerRef || React.createRef();
	}

	componentDidMount() {
		this.setFocus();
	}

	componentDidUpdate() {
		this.setFocus();
	}

	setFocus() {
		const { focus } = this.props;
		if (focus && this.inputRef) {
			this.inputRef.current.focus();
		}
	}

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { className, focus, innerRef, configuration, ...inputProps } = this.props;
		return (
			<TranslationContext.Consumer>
				{(translationContext: ITranslationContextValue) => {
					if (inputProps && inputProps.placeholder) {
						inputProps.placeholder = translationContext.translate(inputProps.placeholder);
					}
					return <input ref={this.inputRef} className={className} {...inputProps} />;
				}}
			</TranslationContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(observer(Input), INPUT_CATEGORY_KEY, INPUT_COMPONENT_KEY);
